<template>
	<div :style="style" class="om-circle-loading"><slot></slot></div>
</template>
<script lang="js">
export default  {
	props : {
		size : {
			type    : String,
			default : '60px',
		},
	},
	computed : {
		style () {
			return this.size ? {
				backgroundSize : this.size,
				height         : this.size,
				minWidth       : this.size,
			} : {}
		},
	},
}
</script>
